// extracted by mini-css-extract-plugin
export var tosLink = "_5t-0";